import { Command } from '@/utils/dialogs';

const commands = {
    onBusinessChange: 'onBusinessChange',
};

const command = Command();

export default { command, commands };
